import React, {useContext} from 'react'
import useSharedStyles from '../useSharedStyles'
import {makeStyles} from '@mui/styles'
import {rxrPrimaryColor} from '../../../assets/styles/color'
import SyncedFiles from '../SyncedFiles'
import {spaceMedium} from '../../../assets/styles/spacing'
import {FormComponentPropTypes} from '../onboardingTypes'
import RejectOrAcceptWithFileAttacher from '../FormCTAs/RejectOrAcceptWithFileAttacher'
import {getSyncedAndNotSyncedFilesFromSubmission} from '../../../Utils/onboardingUtils'
import {WhitelabelContext} from '../OnboardingWhitelabel'

function SecurityDepositAndRent_LinkOut(props) {
  const sharedClasses = useSharedStyles()
  const classes = useStyles()

  const {syncedAttachments, notSyncedAttachments} = getSyncedAndNotSyncedFilesFromSubmission(props.submission)
  const {securityDepositAndRent} = useContext(WhitelabelContext)

  const handleSyncedAttachments = newSyncedAttachmentsArray => {
    props.onUpdateSubmission({
      ...props.submission,
      attachments: [...notSyncedAttachments, ...newSyncedAttachmentsArray],
    })
  }

  return (
    <React.Fragment>
      <div className={sharedClasses.bodyContainer}>
        <div className={classes.linkOutCopy}>
          <p>Check&nbsp;</p>
          <a className={classes.linkOut} rel="noreferrer" href={securityDepositAndRent.paymentLinkOutURL} target="_blank">
            {securityDepositAndRent.paymentLinkOutURL}
          </a>
          <p>&nbsp;to verify payment</p>
        </div>
        <div className={classes.syncedAttachmentsContainer}>
          <SyncedFiles value={syncedAttachments} onChange={handleSyncedAttachments} />
        </div>
      </div>
      <RejectOrAcceptWithFileAttacher submission={props.submission} onUpdateSubmission={props.onUpdateSubmission} />
    </React.Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  linkOutCopy: {
    display: 'flex',
    alignItems: 'center',
  },
  linkOut: {
    color: rxrPrimaryColor,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  syncedAttachmentsContainer: {
    marginTop: spaceMedium,
  },
}))

SecurityDepositAndRent_LinkOut.propTypes = FormComponentPropTypes

export default SecurityDepositAndRent_LinkOut
